import { useFragmentsViewCapture } from '@app/modules/fragments/hooks/useFragmentsViewCapture';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { Box, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { SubtitleDownloadUrls } from './useFragmentSubtitleDownloadUrls';

interface Props {
  /** Signed BFF URLs; when null, actions are disabled (e.g. missing fragment id). */
  downloadUrls: SubtitleDownloadUrls | null;
}

/**
 * Link-style download actions for subtitle formats (TXT, SRT, JSON), matching the media export pattern.
 */
function subtitleLinkProps(url: string | undefined) {
  if (!url) {
    return { component: 'button' as const, disabled: true as const };
  }
  return {
    component: 'a' as const,
    href: url,
    rel: 'noopener noreferrer',
  };
}

export function SubtitleDownloadBtns({ downloadUrls }: Props) {
  const { downloadSubtitles } = useFragmentsViewCapture();

  return (
    <Box mt={1} display="flex" alignItems="center" gap={2} flexWrap="wrap">
      <Button
        {...subtitleLinkProps(downloadUrls?.txt)}
        color="secondary"
        variant="outlined"
        size="small"
        startIcon={<TextSnippetIcon />}
        onClick={() => downloadSubtitles({ format: 'txt' })}
      >
        <FormattedMessage
          id="fragments.subtitlesStatus.download"
          defaultMessage="Descargar subtítulos"
        />{' '}
        <FormattedMessage id="fragments.subtitlesStatus.formatTxt" defaultMessage=".TXT" />
      </Button>
      <Button
        {...subtitleLinkProps(downloadUrls?.srt)}
        color="secondary"
        variant="outlined"
        size="small"
        startIcon={<TextSnippetIcon />}
        onClick={() => downloadSubtitles({ format: 'srt' })}
      >
        <FormattedMessage
          id="fragments.subtitlesStatus.download"
          defaultMessage="Descargar subtítulos"
        />{' '}
        <FormattedMessage id="fragments.subtitlesStatus.formatSrt" defaultMessage=".SRT" />
      </Button>
      <Button
        {...subtitleLinkProps(downloadUrls?.json)}
        color="secondary"
        variant="outlined"
        size="small"
        startIcon={<TextSnippetIcon />}
        onClick={() => downloadSubtitles({ format: 'json' })}
      >
        <FormattedMessage
          id="fragments.subtitlesStatus.download"
          defaultMessage="Descargar subtítulos"
        />{' '}
        <FormattedMessage id="fragments.subtitlesStatus.formatJson" defaultMessage=".JSON" />
      </Button>
    </Box>
  );
}
